import { Config } from '@leverege/plugin';
import { VEHICLE_SALE_STATES, LOCATOR_ALERTS } from '../../constants';
import Util from '../../locatorAlerts/Util';
const opts = {
  filterable: true,
  sortable: false
};
const constants = {
  ...LOCATOR_ALERTS,
  REMOVE_PENDING_SALE: 'pendingRemoveLocator',
  REPLACE_PENDING_SALE: 'pendingReplaceLocator',
  ADD_PENDING_SALE: 'pendingAddLocator'
};
const alertLabels = () => ({
  [constants.THEFT_RECOVERY_ACTIVATED]: 'Theft Recovery Activated',
  [constants.THEFT_RECOVERY_ACTIVATING]: 'Theft Recovery Activating',
  [constants.THEFT_RECOVERY_ENDING]: 'Theft Recovery Ending',
  [constants.REMOVE_PENDING_SALE]: Config.get('PendingSaleMessage', 'label', 'Sale Pending. Unpair Locator'),
  [constants.REPLACE_PENDING_SALE]: 'Sale Pending. Replace Locator',
  [constants.ADD_PENDING_SALE]: 'Sale Pending. Add Locator',
  [constants.POSITION_PENDING]: 'Position Pending',
  [constants.SUSPECTED_DRIVE_OFF]: 'Suspected Drive Off',
  [constants.SUSPECTED_OFF_LOT]: 'Suspected Off Lot',
  [constants.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'Pending Automatic Location Transfer',
  [constants.DEVICE_HEALTH]: 'Device Health Problem',
  [constants.END_OF_LIFE]: 'End of Life',
  [constants.NOT_REPORTING]: 'Not Reporting',
  [constants.NON_OPERATIONAL]: 'Not Operational',
  [constants.SOLD_LOW_BATTERY]: 'Sold with Low Battery',
  [constants.SOLD_OFFLINE]: 'Sold Offline'
});
const alertVariants = {
  [constants.THEFT_RECOVERY_ACTIVATED]: 'pillTheftActive',
  [constants.THEFT_RECOVERY_ACTIVATING]: 'pillTheftActive',
  [constants.THEFT_RECOVERY_ENDING]: 'pillTheftEnding',
  [constants.REMOVE_PENDING_SALE]: 'pillWarning',
  [constants.REPLACE_PENDING_SALE]: 'pillWarning',
  [constants.ADD_PENDING_SALE]: 'pillWarning',
  [constants.POSITION_PENDING]: 'pillPrimary',
  [constants.SUSPECTED_DRIVE_OFF]: 'pillWarning',
  [constants.SUSPECTED_OFF_LOT]: 'pillWarning',
  [constants.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'pill',
  [constants.DEVICE_HEALTH]: 'pillWarning',
  [constants.END_OF_LIFE]: 'pillWarning',
  [constants.NOT_REPORTING]: 'pillWarning',
  [constants.NON_OPERATIONAL]: 'pillWarning',
  [constants.SOLD_LOW_BATTERY]: 'pillWarning',
  [constants.SOLD_OFFLINE]: 'pillWarning'
};
export default {
  id: 'vehicle.calculatedAlerts',
  name: 'vehicle.calculatedAlerts',
  displayName: 'Alerts',
  valueType: 'string',
  objectType: 'vehicle',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const toReturn = [];
    const hasLocator = obj?.data?.locator?.id != null;
    const pendingReplaceSale = obj?.data?.saleState === VEHICLE_SALE_STATES.PENDING_REPLACE_LOCATOR;
    if (hasLocator) {
      const locatorAlerts = obj.data.locator.data?.locatorAlerts || {};
      Object.values(LOCATOR_ALERTS).forEach(val => {
        if (locatorAlerts[val]) {
          toReturn.push(val);
        }
      });
      const pendingRemoveSale = obj?.data?.saleState === VEHICLE_SALE_STATES.PENDING_REMOVE_LOCATOR;
      if (pendingRemoveSale) {
        toReturn.push(constants.REMOVE_PENDING_SALE);
      }
      if (pendingReplaceSale) {
        toReturn.push(constants.REPLACE_PENDING_SALE);
      }
      if (Util.isLocatorNotReporting(obj?.data?.locator)) {
        toReturn.push(constants.NOT_REPORTING);
      }
    } else {
      if (pendingReplaceSale) {
        toReturn.push(constants.ADD_PENDING_SALE);
      }
      const pendingAddSale = obj?.data?.saleState === VEHICLE_SALE_STATES.PENDING_ADD_LOCATOR;
      if (pendingAddSale) {
        toReturn.push(constants.ADD_PENDING_SALE);
      }
    }
    return toReturn;
  }
};
export { alertLabels, alertVariants, constants };